
export default {
    USERS_URL: 'https://jsonplaceholder.typicode.com/users/',
    TODOS_URL: (userId) => `https://jsonplaceholder.typicode.com/todos?userId=${userId}`,
}
